import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { showNotification } from "@shared/store/actions";
import { AccessControl, Button, DragDrop, Icon } from "@shared/components";
import { PERMISSION } from "@shared/constants";
import { SensorDataFile } from "@shared/models";

import "./index.scss";

interface SensorDataFileFormProps {
  onCloseForm: () => void;
  onSubmitForm: (file: File) => void;
  onUploadFile?: (file: File | null) => void;
  uploadedFile?: SensorDataFile | null;
  loading: boolean;
}

const CSV_TYPES: string[] = ["csv"];
const MAX_CSV_FILE_SIZE = 950;

const SensorDataFileForm: React.FunctionComponent<SensorDataFileFormProps> = (props) => {
  const { onCloseForm, onSubmitForm, loading, uploadedFile, onUploadFile } = props;

  const dispatch = useDispatch();
  const [file, setFile] = useState<File | null>(null);

  const handleFileSubmit = useCallback(() => {
    if (!file) {
      dispatch(
        showNotification({
          message: "CSV file is required",
          appearance: "error",
        }),
      );
      return;
    }

    onSubmitForm(file);
  }, [dispatch, file, onSubmitForm]);

  const handleFileUpload = useCallback(
    (file: File | null) => {
      setFile(file);
      onUploadFile && onUploadFile(file);
    },
    [onUploadFile],
  );

  return (
    <div className="sensor-form">
      <div className="sensor-form-header">
        <div className="sensor-form-header-left">{uploadedFile ? "File Results" : "Upload File"} </div>
        <div className="sensor-form-header-right">
          {!loading ? (
            <>
              {!uploadedFile ? (
                <AccessControl permission={PERMISSION.CREATE_SENSOR_DATA_FILE}>
                  <Button type="submit" className="action-btn" onClick={handleFileSubmit}>
                    Upload
                  </Button>
                </AccessControl>
              ) : null}
              <Button className="close-btn" onClick={() => onCloseForm()}>
                <Icon type="clear" />
              </Button>
            </>
          ) : null}
        </div>
      </div>
      <div className="sensor-form-content">
        {!uploadedFile ? (
          <DragDrop onUploadFile={handleFileUpload} types={CSV_TYPES} maxFileSize={MAX_CSV_FILE_SIZE} />
        ) : null}
      </div>
    </div>
  );
};

export default SensorDataFileForm;
